// extracted by mini-css-extract-plugin
export default {"ResumeLoginBanner":"QIcKn","ResumeLoginBanner__content":"YzaGv","ResumeLoginBanner__description":"ikBKV","ResumeLoginBanner__btn":"BRXtz","ResumeLoginBanner__icon":"yt98K"};